/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Sidebar, Text } from "@nordcloud/gnui";
import { EditButton } from "~/components/InlineEdit";
import FlexContainer from "~/components/Styled/FlexContainer";
import { CapacityBasedFeeTypeEnum } from "~/models/assignmentRule";
import { Environment } from "~/models/environment";
import { displayLevel, toPercentage } from "~/tools/";
import { EnvServiceLevel } from "./EnvServiceLevel";
import { EnvServiceLevelClear } from "./EnvServiceLevelClear";

type InlineServiceLevelEnvProps = {
  environment: Environment;
  refetch: () => Promise<void>;
  canEdit?: boolean;
};

function InlineServiceLevelEnv({
  environment,
  refetch,
  canEdit = true,
}: InlineServiceLevelEnvProps) {
  const [isEditMode, setIsEditMode] = React.useState(false);

  const effectiveFee =
    environment?.attachedServiceLevel?.effectiveCapacityBasedPercentageFee;

  const capacityFeeType =
    environment?.attachedServiceLevel?.capacityBasedFeeType;

  return (
    <>
      <FlexContainer justify="center" align="center">
        <Text tag="div" mr="0.5rem">
          {displayLevel(environment?.attachedServiceLevel?.serviceLevel?.name)}
        </Text>
        {effectiveFee && (
          <Text tag="div" mr="0.5rem">
            Capacity Based Fee:{" "}
            {capacityFeeType ===
            CapacityBasedFeeTypeEnum.INCLUDED_IN_BASE_FEE_TYPE
              ? "Included In Base Fee"
              : `${toPercentage(effectiveFee)} %`}
          </Text>
        )}
      </FlexContainer>
      {canEdit && <EditButton onClick={() => setIsEditMode(true)} />}
      {environment.attachedServiceLevel && canEdit && (
        <EnvServiceLevelClear environment={environment} refetch={refetch} />
      )}
      <Sidebar
        isOpen={isEditMode}
        title="Edit Service level"
        onClick={() => setIsEditMode(false)}
      >
        {isEditMode && (
          <EnvServiceLevel
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            environment={environment}
            refetch={refetch}
          />
        )}
      </Sidebar>
    </>
  );
}

export { InlineServiceLevelEnv };
